var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcAnalytics(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10617",
    "data-name": "Group 10617",
    transform: "translate(-350 -244)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_104",
    "data-name": "Rectangle 104",
    width: 30,
    height: 30,
    transform: "translate(350 244)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "chart-pie-alt",
    transform: "translate(353.133 246.855)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5416",
    "data-name": "Path 5416",
    d: "M18.556,11.385H14.011A1.388,1.388,0,0,1,12.618,10V5.433a3.432,3.432,0,0,0-1.331-2.722A3.307,3.307,0,0,0,8.436,2.1,11.112,11.112,0,1,0,21.9,15.579a3.309,3.309,0,0,0-.61-2.858,3.49,3.49,0,0,0-2.734-1.336Zm.433,3.459A8.115,8.115,0,1,1,9.167,5.009.3.3,0,0,1,9.239,5a.331.331,0,0,1,.2.077.461.461,0,0,1,.176.356V9.994a4.389,4.389,0,0,0,4.393,4.39h4.545a.467.467,0,0,1,.365.18A.311.311,0,0,1,18.989,14.844Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5417",
    "data-name": "Path 5417",
    d: "M23.651,7.446A10.073,10.073,0,0,0,16.582.372,2.014,2.014,0,0,0,14.019,2.3V7a3,3,0,0,0,3,3h4.719a2.008,2.008,0,0,0,1.913-2.554Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAnalytics);
export default __webpack_public_path__ + "static/media/ic_analytics.2327a2c58aef7ef30d9ce5274d05bc3d.svg";
export { ForwardRef as ReactComponent };